import { Component, OnInit, Input, Optional, Inject } from '@angular/core';
import { NgxExcelComponentRef, NgxExcelComponent } from '../ngx-excel/ngx-excel.component';
import { NgxExcelAction, NgxExcelActionScope, NgxExcelContextChanged, NgxExcelContextMenuClickedEvent } from '../../models/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'ngx-excel-context-action',
  template: ''
})

export class NgxExcelContextActionComponent implements OnInit {

  private _invisible = false;
  private _disabled = false;
  private _prefix = false;
  // protected actionDisabled: (context: T) => boolean;
  // protected actionHidden: (context: T) => boolean;

  @Input() label: string;
  @Input() action: string;
  @Input() icon: string;
  @Input() scope: NgxExcelActionScope = NgxExcelActionScope.Context;
  @Input() execute: (payload: NgxExcelContextMenuClickedEvent) => Observable<NgxExcelContextChanged[]> | void;

  /*@Input()
  set disabled(value: boolean | ((context: T) => boolean)) {
      if (typeof(value) === 'function') {
          this.actionDisabled = value;
      } else {
          this.actionDisabled = () => value === false ? false : true;
      }
  }*/

  @Input()
  set invisible(value: boolean) { this._invisible = value === false ? false : true; }
  get invisible(): boolean { return this._invisible; }

  @Input()
  set disabled(value: boolean) { this._disabled = value === false ? false : true; }
  get disabled(): boolean { return this._disabled; }

  /*@Input()
  set hidden(value: boolean | ((context: T) => boolean)) {
      if (typeof(value) === 'function') {
          this.actionHidden = value;
      } else {
          this.actionHidden = () => value === false ? false : true;
      }
  }*/

  // @Input() enabledFn: (context: T) => boolean;
  // @Input() visibleFn: (context: T) => boolean;
  @Input()
  set prefix(value: boolean) { this._prefix = value === false ? false : true; }
  get prefix(): boolean { return this._prefix; }

  constructor(
    @Optional() @Inject(NgxExcelComponentRef) protected excelComponent: NgxExcelComponent
  ) { }

  ngOnInit() {
    const action = this.action || '';
    const label = this.label || '';
    if (!this.excelComponent || action.length === 0 || label.length === 0) { return; }

    const excelAction = {} as NgxExcelAction;
    excelAction.label = label;
    excelAction.action = action;
    excelAction.icon = this.icon;
    excelAction.prefix = this._prefix;
    excelAction.actionScope = this._prefix ? NgxExcelActionScope.Excel : this.scope;
    excelAction.execute = this.execute || null;
    excelAction.invisible = this._invisible;
    excelAction.disabled = this._disabled;

    /*excelAction.enabled     = (payload) => this.actionDisabled ? !this.actionDisabled(payload.context) : true;
    excelAction.visible     = (payload) => {
        if (this.actionHidden) { return !this.actionHidden(payload.context); }
        if (this.scope === NgxExcelActionScope.Column) { return !!payload.context && !!payload.column; }
        if (this.scope === NgxExcelActionScope.Context) { return !!payload.context; }
        return true;
    };*/

    if (excelAction.label.length === 0 || excelAction.action.length === 0) { return; }
    this.excelComponent.addExcelAction(excelAction);
  }
}
